import { Box } from "@chakra-ui/react"

export const RootUi = ({ children }: any) => {

    return (
        <Box className="flex flex-col h-screen">
            {children}
        </Box>
    )
}